var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyNonVegFoodNotAllowed = function SvgHappyNonVegFoodNotAllowed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF5F7",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF3A5C",
    d: "M14.249 5H5.723A.723.723 0 0 0 5 5.724v8.552c0 .4.323.724.723.724h8.526a.723.723 0 0 0 .722-.724V5.724c0-.4-.323-.724-.723-.724Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A5C",
    d: "M12.963 9.796a2.98 2.98 0 0 1-2.977 2.987 2.98 2.98 0 0 1-2.978-2.987A2.98 2.98 0 0 1 9.986 6.81a2.98 2.98 0 0 1 2.977 2.986"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#happyNonVegFoodNotAllowed_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FF3A5C",
    strokeLinecap: "round",
    d: "M16 4.707 4.707 16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "happyNonVegFoodNotAllowed_svg__a",
    width: 12.293,
    height: 13.293,
    x: 4.207,
    y: 3.207,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.960784 0 0 0 0 0.968627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3008_83"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3008_83",
    result: "shape"
  })))));
};
export default SvgHappyNonVegFoodNotAllowed;